import { CAMERA_GIMBALS, adjustableCameraFraming, effectiveCameraGimbal, type CameraGimbalId } from '../../../renderer/src/camera-gimbal';
import type { CameraDistanceId, CameraPlatformId } from '../../../renderer/src/presets';

export const cameraGimbalLabel = (value: CameraGimbalId) => CAMERA_GIMBALS.find(item => item.id === value)!.label;

/** The setting displayed by the select and its section summary. */
export function cameraGimbalDisplay(value: CameraGimbalId, distance: CameraDistanceId, style: CameraPlatformId, keyframing = false) {
  const active = style !== 'uav' && adjustableCameraFraming(distance);
  const displayed = active || keyframing ? value : effectiveCameraGimbal(value, distance, style);
  return { active, selectable: active || keyframing, value: displayed, label: cameraGimbalLabel(displayed) };
}
